import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import { IMarketSegment, INegotiatingTactic, IRegion, ISalesDistrict, ISourceOfPower } from '../lookups';
import { ISalesDistrictDealerGoal } from './salesAdminInterfaces';

export async function deleteObj(endpoint: AdminSalesEndpoints, id: number) {
  return executeApiRequest(() => httpService.delete(ApiUrls.adminSales(endpoint, id)), false);
}

export async function DeleteRegion(regionId: number): Promise<void> {
  try {
    await httpService.delete(ApiUrls.adminSales('Regions', regionId));
  } catch (e) {
    throw e;
  }
}

export async function deleteSourceOfPower(sourceOfPowerId: number): Promise<IApiExecuteRespone> {
  return executeApiRequest(() => httpService.delete(ApiUrls.adminSales('SourcesOfPower', sourceOfPowerId)), false);
}

export async function FetchSalesDistricts(): Promise<ISalesDistrict[]> {
  try {
    const response = await httpService.get(ApiUrls.adminSales('SalesDistricts'));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchSalesDistrictGoals(
  fiscalYear: string,
  salesDistricts: string[]
): Promise<IApiExecuteRespone<ISalesDistrictDealerGoal[]>> {
  return executeApiRequest(() => httpService.get(ApiUrls.adminSalesDistrictGoals(fiscalYear, salesDistricts)));
}

export async function saveNegotiatingTactic(
  negotiatingTactic: INegotiatingTactic
): Promise<IApiExecuteRespone<INegotiatingTactic>> {
  return executeApiRequest(() => httpService.post(ApiUrls.adminSales('NegotiatingTactics'), negotiatingTactic));
}

export async function saveSourceOfPower(sourceOfPower: ISourceOfPower) {
  return executeApiRequest<ISourceOfPower>(() => httpService.post(ApiUrls.adminSales('SourcesOfPower'), sourceOfPower));
}

export async function SaveRegion(region: IRegion): Promise<IRegion[]> {
  try {
    const response = await httpService.post(ApiUrls.adminSales('Regions'), region);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function SaveSalesDistricts(sd: ISalesDistrict): Promise<ISalesDistrict[]> {
  try {
    const response = await httpService.post(ApiUrls.adminSales('SalesDistricts'), sd);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function saveSalesDistrictGoal(goal: { old: ISalesDistrictDealerGoal; new: ISalesDistrictDealerGoal }) {
  return executeApiRequest<ISalesDistrictDealerGoal>(() => httpService.post(ApiUrls.adminSalesDistrictGoals(), goal));
}

export async function UpdateRegion(region: IRegion): Promise<IRegion[]> {
  try {
    const response = await httpService.put(ApiUrls.adminSales('Regions', region.regionId), region);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateSalesAdminObj(endPoint: AdminSalesEndpoints, obj: object) {
  return executeApiRequest<IMarketSegment>(() => httpService.post(ApiUrls.adminSales(endPoint), obj));
}

export type AdminSalesEndpoints =
  | 'BusinessEntityRankTypes'
  | 'CallObjectives'
  | 'CallTypes'
  | 'MarketSegments'
  | 'NegotiatingTactics'
  | 'ProspectLifeCycles'
  | 'Regions'
  | 'SalesDistricts'
  | 'SourcesOfPower'
  | 'ProductCategories';
